<!-- Start Page Title Area -->

<div class="page-title-area upper-margin">
    <div class="container">
        <div class="page-title-content">
            <br />
            <br />
            <h2>{{'Occasions' | translate }}</h2>
            <!--<a routerLink="/">{{'Home' | translate }}/</a>-->
        </div>
    </div>
</div>
<!-- End Page Title Area -->
<!-- Start Products Area -->
<!-- End Products Area -->
<div class="bg-color section-margin">
    <div class="containers">

        <div class="row">
            <!-- data-aos="fade-up" data-aos-delay="100"-->
            <div class="title">
                <h4>{{ CategoryName }}</h4>
                <p>{{'We_found' | translate }} <strong>{{ dataSourceTag.data.length }}</strong> {{'products_available_for_you' | translate }}</p>
            </div>
            <!-- data-aos="fade-up" data-aos-delay="100"-->
            <!--<div class="col-lg-4 col-md-6 ordering">
                <div>
                    <label>{{ 'Sort_By' | translate }}</label><br /><br />
                    <select class="form-select" (change)="onSortChange($event)">
                        <option value="Default">{{'Default' | translate }}</option>
                        <option value="Low to High">{{'Price_Low_to_High' | translate }}</option>
                        <option value="High to Low">{{'Price_High_to_Low' | translate }}</option>
                    </select>
                </div>
            </div>-->

        </div><br />
        <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-6 col-6 mt-3"
                 *ngFor="let item of dataSourceTag.data; let i = index">
                <!-- data-aos="flip-right"-->

                <div class="partner-item mx-2 mt-2" style="justify-content: center;">
                    <a class="box d-flex" style="border-radius: 15px; min-height: 200px; max-height: 200px; min-width: 200px; max-width: 200px; justify-content: center;"  (click)="onClickTag(item.inTagID)" href="javascript:void(0);">
                        <img [src]="apiURL + item.photoPath" alt="image" style="max-height: 180px; max-width: 180px; ">
                    </a>
                    <h5 class="mt-3">
                        <ng-template *ngIf="SelectedLanguage == 'ar'; then other_ItemAr; else other_ItemEn">
                        </ng-template>
                        <ng-template #other_ItemAr>{{ item.nameAr }}</ng-template>
                        <ng-template #other_ItemEn>{{ item.name }}</ng-template>
                    </h5>
                </div>
            </div>

        </div>
        <!--<div class="col-lg-12 col-md-12 col-sm-12 my-3">
            <div class=" text-center">
                <pagination-controls (pageChange)="onPageClick($event)"></pagination-controls>
            </div>
        </div>-->

    </div>

</div>
